import { render } from "./SponsorCodesFAQ.vue?vue&type=template&id=2f477ee5&scoped=true"
import script from "./SponsorCodesFAQ.vue?vue&type=script&lang=js"
export * from "./SponsorCodesFAQ.vue?vue&type=script&lang=js"

import "./SponsorCodesFAQ.vue?vue&type=style&index=0&id=2f477ee5&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f477ee5"]])

export default __exports__